module.exports = __webpack_public_path__ + "static/img/member_detail.266c403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/member_detail.png
// module id = RQfI
// module chunks = 1